import { HttpHeaders } from '@angular/common/http';
import { Component, ChangeDetectorRef, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { ExternalLibraryService } from '../util';
import * as moment from 'moment';
import { QuizService } from 'src/app/shared-service/services/quiz.service';
import { AppConfig } from 'src/app/app.config';
import { FormBuilder, FormGroup } from '@angular/forms';
declare let Razorpay: any;

@Component({
  selector: 'app-payments',
  templateUrl: './payments.component.html',
  styleUrls: ['./payments.component.css']
})
export class PaymentsComponent implements OnInit, OnDestroy {
  subscription: Subscription;
  orderData = {};
  RAZORPAY_KEY_ID ='';
  RAZORPAY_KEY_SECRET='';
  paymentGatewayName='';

  tranxnForm : FormGroup;
  processStateForm : FormGroup;

  @ViewChild('txnForm') txnForm: any;
  @ViewChild('procssForm') procssForm: any;
  isgPay_url:any;
  EncDataField:string;
  MerchantIdField:string;
  TransactionId:string = 'TXN20230227230036';
  BankIdField:string;
  TerminalIdField:string ;
  VersionField:string;

  customerId:string;


  amountField:string;
  useridField:string ;
  statusField:string;
  book:any;

  package_id: string;
            customer_id:string;
            coupon_code: string;
            grand_total:string;
            order_via:string;
            payment_status:string;
            plan_for:string;
            plan_id:string;
            type:string;
            course_id: string;
            subscription_id: string;
            order_id: string;

  constructor(private cd:  ChangeDetectorRef,
     private quizService: QuizService,private config: AppConfig,
     private formBuilder: FormBuilder) {
    this.isgPay_url = this.config.getConfig('PAYMENT_GATEWAY_LINK');
    this.paymentGatewayName = this.config.getConfig('PAYMENT_GATEWAY_NAME');
    // this.EncDataField = this.config.getConfig('ISG_PAY_ENC_DATA');
    // this.MerchantIdField = this.config.getConfig('ISG_PAY_MERCHANT_ID');
    // this.BankIdField = this.config.getConfig('ISG_PAY_BANK_ID');
    // this.TerminalIdField = this.config.getConfig('ISG_PAY_TERMINAL_ID');
    // this.VersionField = this.config.getConfig('ISG_PAY_VERSION');
    this.customerId = this.config.getConfig('CUSTOMER_ID');
    this.tranxnForm = this.formBuilder.group({
      Version:[''],
      TerminalId: [''],
      BankId: [''],
      MerchantId: [''],
      EncData:[''],
      TransactionId:['']

           });
           
    this.processStateForm = this.formBuilder.group({
            amount:[''],
            user_id: [''],
            status: [''],
            package_id: [''],
            customer_id:[''],
            coupon_code: [''],
            grand_total:[''],
            order_via:[''],
            payment_status:[''],
            plan_for:[''],
            plan_id:[''],
            type:[''],
            course_id: [''],
            subscription_id: [''],
            order_id: [''],
            book:['']

      });
    this.subscription = this.quizService.getRazorPaydata().subscribe(data => {
      if (data) {
        let subAmount = '';
        let am = data.orderData.amount;
        if(am.indexOf('.') != -1) {
          am = am.replace('.','');
          subAmount = am
        } else {
          subAmount = am + '00';
        }
        var checkZeroValueCase = Math.round(am);
        if(checkZeroValueCase == 0) {
                  data.orderData.subscriberData.order_status = 'success';
                  data.orderData.subscriberData.payment_status = 'success'
                  data.orderData.subscriberData.txn_id = 'temp_paymentId';
                  data.orderData.subscriberData.order_id = 'temp_orderId';
                  if(!data.orderData.subscriberData.plan_for) {
                    data.orderData.subscriberData.plan_for = 'Plan'
                  }
                  data.orderData.subscriberData.order_date = moment(new Date()).format('DD-MM-YYYY HH:mm:SS');
                  this.quizService.checkoutNewMob(data.orderData.subscriberData).subscribe((res: any) => {
                      window.location.reload();
                    });
        } else {
          // let createData = { "amount": subAmount };
          // this.quizService.createOrder(createData).subscribe((response: any) => {
          //   if (response && response.data) {
          //     let subData = data.orderData.subscriberData;
          //     subData['order_id'] = response.data.id;
          //     subData['receipt'] = response.data.receipt;
          //     data.orderData.subscriberData = subData;
          //     this.orderData = data.orderData;
              
          //   }
          // });

          this.defaultRazorPayEntry('', data.orderData.amount, data.orderData.subscriberData);


        }
       
        // this.procssForm.nativeElement.submit();

        // let createData = { "amount": subAmount};
        // this.quizService.createOrder(createData).subscribe((response: any) => {
        //   if(response && response.data) {
        //     // let subData = data.orderData.subscriberData;
        //     // subData['order_id'] = response.data.id;
        //     // subData['receipt'] = response.data.receipt;
        //     // data.orderData.subscriberData = subData;
        //     // this.orderData = data.orderData;
        //     // this.proceed(data.orderData.orderId, data.orderData.amount, data.orderData.subscriberData);

        //     // this.TerminalIdField =  response.data.id;
        //     this.tranxnForm.controls.EncData.setValue(this.EncDataField);
        //     this.tranxnForm.controls.MerchantId.setValue(this.MerchantIdField);
        //     this.tranxnForm.controls.BankId.setValue(this.BankIdField);
        //     this.tranxnForm.controls.TerminalId.setValue(this.TerminalIdField);
        //     this.tranxnForm.controls.Version.setValue(this.VersionField);
        //     this.tranxnForm.controls.TransactionId.setValue(this.TransactionId);
        //     this.txnForm.nativeElement.submit();
        //   }
        // });

      }
    });
  }

  name = 'Angular';
  response;
  razorpayResponse;
  showModal = false;



  ngOnInit() {
    // this.razorpayService
    // .lazyLoadLibrary('https://checkout.razorpay.com/v1/checkout.js')
    // .subscribe();
  }

  public defaultRazorPayEntry(orderId, amount, subscriberData) {
    let subAmount = '';
    if (subscriberData.grand_total.indexOf('.') != -1) {
      subscriberData.grand_total = subscriberData.grand_total.replace('.', '');
      subAmount = subscriberData.grand_total
    } else {
      subAmount = subscriberData.grand_total + '00';
    }

    subscriberData.status = 'initiated';
    subscriberData.gateway = this.paymentGatewayName;
    subscriberData.order_status = 'initiated';
    subscriberData.order_status = 'initiated';
    // subscriberData.order_date = new Date();
    subscriberData.order_date = moment(new Date()).format('DD-MM-YYYY HH:mm:SS');
    if(subscriberData.product_list && subscriberData.product_list.length) {
      subscriberData.book = subscriberData.product_list;
      delete subscriberData.product_list;
      subscriberData.grand_total = subscriberData.grand_total + '00';
    }
    if (subscriberData.grand_total && subscriberData.grand_total.indexOf('.') == -1) {
      let indexedAmount = subscriberData.grand_total.substring(0, subscriberData.grand_total.length - 2) + '.' + subscriberData.grand_total.substring(subscriberData.grand_total.length - 2, subscriberData.grand_total.length);
      subscriberData.grand_total = indexedAmount;
      subscriberData.amount = indexedAmount;
    }
    
    this.quizService.checkoutNewMob(subscriberData).subscribe((res: any) => {
      if(res && res.data) {
        // this.proceed(orderId, amount, subscriberData);
        this.amountField = subAmount;
        this.statusField = 'pending';
        this.useridField = subscriberData.user_id;
        this.processStateForm.controls.amount.setValue(this.amountField);
        this.processStateForm.controls.status.setValue(this.statusField);
        this.processStateForm.controls.user_id.setValue(this.useridField);
        this.processStateForm.controls.order_id.setValue(res.data.order_id);
        this.processStateForm.controls.customer_id.setValue(this.customerId);
        this.processStateForm.controls.coupon_code.setValue(subscriberData.coupon_code);
        this.processStateForm.controls.grand_total.setValue(subscriberData.grand_total);
        this.processStateForm.controls.order_via.setValue(subscriberData.order_via);
        this.processStateForm.controls.package_id.setValue(subscriberData.package_id);
        this.processStateForm.controls.payment_status.setValue(subscriberData.payment_status);
        this.processStateForm.controls.plan_for.setValue(subscriberData.plan_for);
        this.processStateForm.controls.plan_id.setValue(subscriberData.plan_id);
        this.processStateForm.controls.subscription_id.setValue(subscriberData.subscription_id);
        this.processStateForm.controls.type.setValue(subscriberData.type);
        this.processStateForm.controls.course_id.setValue(subscriberData.course_id);
        this.procssForm.nativeElement.submit();

      } else {
        // some error occured
        window.location.reload();
      }
    });
  }


  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  _self = this;

  // RAZORPAY_OPTIONS = {
  //   "key": this.config.getConfig('RAZORPAY_KEY_ID'),
  //   "amount": "",
  //   "name": this.config.getConfig('RAZORPAY_NAME'),
  //   "description":this.config.getConfig('RAZORPAY_DESCRIPTION'),
  //   "order_id": "",
  //   "image": this.config.getConfig('RAZORPAY_LOGO'),
  //   "prefill": {
  //     "name": "",
  //     "email": "",
  //     "contact": "",
  //     "method": ""
  //   },
  //   "modal": {
  //   },
  //   "theme": {
  //     "color":  this.config.getConfig('RAZORPAY_THEME_COLOR')
  //   }
  // };

  // httpOptions = {
  //   headers: new HttpHeaders({
  //     'Content-Type':  'application/json',
  //     'Authorization': 'Basic ' + btoa(this.config.getConfig('RAZORPAY_KEY_ID')+':'+this.config.getConfig('RAZORPAY_KEY_SECRET')),
  //   })
  // };



//   public proceed(orderId, amount, subscriberData) {
//     if(amount.indexOf('.') != -1) {
//       amount = amount.replace('.','');
//       this.RAZORPAY_OPTIONS.amount = amount
//     } else {
//       this.RAZORPAY_OPTIONS.amount = amount + '00';
//     }
//     //added extra
//     this.RAZORPAY_OPTIONS.order_id = subscriberData.order_id;
//     let userData = JSON.parse(localStorage.getItem('userData'));
//     if(userData) {
//       this.RAZORPAY_OPTIONS['prefill']['name'] = userData['first_name'];
//       if(userData['last_name']) {
//         this.RAZORPAY_OPTIONS['prefill']['name'] = userData['first_name'] + ' ' + userData['last_name'];
//       }
//       this.RAZORPAY_OPTIONS['prefill']['email'] = userData['email'];
//       this.RAZORPAY_OPTIONS['prefill']['contact'] = userData['mobile'];
//     }


//    // this.RAZORPAY_OPTIONS.order_id = orderId;

//     // binding this object to both success and dismiss handler
//     this.RAZORPAY_OPTIONS['handler'] = this.razorPaySuccessHandler.bind(this, subscriberData, orderId);
//     this.RAZORPAY_OPTIONS['modal']['ondismiss'] = this.razorPayCloseHandler.bind(this, subscriberData, orderId);
//     // this.showPopup();

//     let razorpay = new Razorpay(this.RAZORPAY_OPTIONS);

//     var me = this;

//     razorpay.on('payment.failed', function (response){
//       let indexAmount = me.orderData['amount'];
//       let bodyData = {
//         amount: indexAmount,
//         payment_id : response.error.metadata.payment_id
//       }
//       let subscriberData1 = me.orderData['subscriberData'];
//       subscriberData.txn_id = response.error.metadata.payment_id;
//       if(response.error.reason && response.error.reason == 'payment_failed') {
//         me.quizService.sendPaymentIdToServer(response.error.metadata.payment_id, bodyData).subscribe((result: any) => {
//           if(result && result.data && result.data.error) {
//             subscriberData1.order_status = 'failed';
//             subscriberData1.gateway = 'Razorpay';
//             subscriberData1.order_status = 'failed';
//             subscriberData1.order_date = moment(new Date()).format('DD-MM-YYYY HH:mm:SS');
//             if(subscriberData1.grand_total && subscriberData1.grand_total.indexOf('.') == -1) {
//               let indexedAmount = subscriberData1.grand_total.substring(0, subscriberData1.grand_total.length -2) + '.' +  subscriberData1.grand_total.substring(subscriberData1.grand_total.length -2, subscriberData1.grand_total.length);
//               subscriberData1.grand_total = indexedAmount;
//               subscriberData1.amount = indexedAmount;
//             }
//             me.quizService.checkoutNewMob(subscriberData1).subscribe((res: any) => {
//               window.location.reload();
//             });
//           } else if(result && result.data && result.data.entity == 'payment') {
//             subscriberData1.order_status = 'failed';
//             subscriberData1.gateway = 'Razorpay';
//             subscriberData1.order_status = 'failed';
//             subscriberData1.order_date = moment(new Date()).format('DD-MM-YYYY HH:mm:SS');
//             if(subscriberData1.grand_total && subscriberData1.grand_total.indexOf('.') == -1) {
//               let indexedAmount = subscriberData1.grand_total.substring(0, subscriberData1.grand_total.length -2) + '.' +  subscriberData1.grand_total.substring(subscriberData1.grand_total.length -2, subscriberData1.grand_total.length);
//               subscriberData1.grand_total = indexedAmount;
//               subscriberData1.amount = indexedAmount;
//             }
//             me.quizService.checkoutNewMob(subscriberData1).subscribe((res: any) => {
//               window.location.reload();
//             });
//           }else {
//             window.location.reload();
//           }
//         });
//       } else {
//         me.quizService.sendPaymentIdToServer(response.error.metadata.payment_id, bodyData).subscribe((result: any) => {
//           if(result && result.data) {
//             subscriberData1.gateway = 'Razorpay';
//             subscriberData1.order_status = 'failed';
//             subscriberData1.order_status = 'failed';
//             subscriberData1.order_date = moment(new Date()).format('DD-MM-YYYY HH:mm:SS');
//             if(subscriberData1.grand_total && subscriberData1.grand_total.indexOf('.') == -1) {
//               let indexedAmount = subscriberData1.grand_total.substring(0, subscriberData1.grand_total.length -2) + '.' +  subscriberData1.grand_total.substring(subscriberData1.grand_total.length -2, subscriberData1.grand_total.length);
//               subscriberData1.grand_total = indexedAmount;
//               subscriberData1.amount = indexedAmount;
//             }
//             me.quizService.checkoutNewMob(subscriberData1).subscribe((res: any) => {
//               window.location.reload();
//             });
//           } else {
//             window.location.reload();
//           }
//         });
//       }
// });
//     razorpay.open();
//   }

//   public razorPayCloseHandler(subscriberData, orderId, razorPayresponse) {
//     this.quizService.setSubButtonHandler(true);
//   }

//   public razorPaySuccessHandler(subscriberData, orderId, razorPayresponse) {
//     subscriberData.txn_id = razorPayresponse.razorpay_payment_id;
//     subscriberData.gateway = razorPayresponse.org_name;

//     let subAmount = '';
//     if(subscriberData.grand_total.indexOf('.') != -1) {
//       subscriberData.grand_total = subscriberData.grand_total.replace('.','');
//       subAmount = subscriberData.grand_total
//     } else {
//       subAmount = subscriberData.grand_total + '00';
//     }


//     let bodyData = {
//       amount: subAmount,
//       payment_id : razorPayresponse.razorpay_payment_id
//     }

//     this.quizService.sendPaymentIdToServer(razorPayresponse.razorpay_payment_id, bodyData).subscribe((result: any) => {
//       if(result && result.data) {
//         subscriberData.status = result.data.status;
//         subscriberData.gateway = 'Razorpay';
//         if(subscriberData.status == 'captured' || subscriberData.status == 'authorized') {
//           subscriberData.order_status = 'success';
//           subscriberData.order_status = 'success';
//         }
//        // subscriberData.order_date = new Date();
//         subscriberData.order_date = moment(new Date()).format('DD-MM-YYYY HH:mm:SS');
//         if(subscriberData.grand_total && subscriberData.grand_total.indexOf('.') == -1) {
//           let indexedAmount = subscriberData.grand_total.substring(0, subscriberData.grand_total.length -2) + '.' +  subscriberData.grand_total.substring(subscriberData.grand_total.length -2, subscriberData.grand_total.length);
//           subscriberData.grand_total = indexedAmount;
//           subscriberData.amount = indexedAmount;
//         }
//         this.quizService.checkoutNewMob(subscriberData).subscribe((res: any) => {
//           window.location.reload();
//         });
//       } else {
//         window.location.reload();
//       }
//     })
//   }

}